import cookie from 'js-cookie';
import type { User } from 'types/User';
import * as uuid from 'uuid';

import facebook from '~/services/facebook';
import facebookPixel from '~/services/facebook.pixel';
import tiktok from '~/services/tiktok.pixel';
import twitter from '~/services/twitter.pixel';

import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  user: User;
};

class CompleteRegistrationEvent extends UserEvent<EventData> {
  async sendToFacebook() {
    const eventId = uuid.v4();

    await facebookPixel.fireCustomEvent(
      facebookPixel.CustomEventNames.CompleteRegistration,
      { eventID: eventId }
    );

    const hashedProfile = await facebook.getHashedProfile(
      this.data.user.profile
    );

    const serverEventData = [
      {
        action_source: 'website',
        event_id: eventId,
        event_name: facebookPixel.CustomEventNames.CompleteRegistration,
        event_time: Math.floor(Date.now() / 1000),
        user_data: {
          client_ip_address: this.data.clientIp,
          client_user_agent: navigator.userAgent,
          external_id: this.data.user.id ?? 'guest',
          fbc: cookie.get('_fbc'),
          fbp: cookie.get('_fbp'),
          ...hashedProfile
        }
      }
    ];

    this.serverEvents.push({ data: serverEventData, type: 'facebook' });
  }

  sendToTikTok() {
    return tiktok.fireEvent('CompleteRegistration');
  }

  sendToTwitter() {
    return twitter.fireEvent(twitter.EventIds.CompleteRegistration);
  }
}

export default CompleteRegistrationEvent;
